function encode(param: any): string {
    return param === undefined ? '' : encodeURIComponent(param);
}

export default function url(strings: TemplateStringsArray, ...params: any[]): string {
    return strings.reduce((acc, str, i) => `${acc}${str}${encode(params[i])}`, '');
}
